import React, { Component } from "react";
import $ from "jquery";

import Loader from "../components/loader";
import { renderErrorMessage } from "../helper/user_helper";
import { getQuestions } from "../helper/question_helper";
// import QuestionRow from "../components/questionRow";
// import AnswerLine from "../components/answers/answer_line";
import YaystackNavBar from "../components/yaystackNavBar";

import { getUser } from "../helper/user_helper";

import ListQuestionAnswer from "../components/list/interface/list_question_answer";

class ListQuestions extends Component {
  state = {
    errors: "",
    loaded: false,
    questions: [],
    current_page: 1,
    total_pages: 1,
    can_load_more: true,
    user: null
  };

  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.getQuestionsPage(this.state.current_page);
    this.refContainer.addEventListener("scroll", this.handleScroll);

    this.userCall = getUser();
    this.userCall.promise.then(answer => {
      if (answer.signedIn === true) {
        this.setState({ signedIn: true, user: answer.user });
      }
    });
  }

  componentWillUnmount() {
    if (this.questionsCall) {
      this.questionsCall.cancel();
    }
    if (this.userCall) {
      this.userCall.cancel();
    }
    this.refContainer.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    return (
      <React.Fragment>
        <YaystackNavBar />
        {this.renderQuestionsListPage()}
      </React.Fragment>
    );
  }

  handleScroll() {
    if (this.state.can_load_more === false) {
      // Checking if we are not already loading more data
      return;
    }
    if (this.state.current_page >= this.state.total_pages) {
      // We don't check anything if questions doesn't have other questions
      return;
    }
    if (
      $("#questions").scrollTop() + $("#questions").innerHeight() >=
      $("#questions")[0].scrollHeight
    ) {
      // Load More questions
      this.setState({ can_load_more: false });
      const current_page = this.state.current_page + 1;
      this.setState({ current_page });
      this.getQuestionsPage(this.state.current_page);
    } else {
      // Nothing
    }
  }

  renderQuestionsListPage() {
    const self = this;
    var questions = this.state.questions.map(function(question) {
      return (
        <ListQuestionAnswer
          key={question.id}
          question={question}
          addAnswer={self.addAnswer}
          user={self.state.user}
          list_fullscreen={self.list_fullscreen}
          history={self.props.history}
          removeAnswer={self.removeAnswer}
          link={true}
        />
      );
    });
    return (
      <div
        id="questions"
        className="center list_questions list profilePage allow_scroll"
        ref={ref => {
          this.refContainer = ref;
        }}
      >
        <div className="max_width_500">
          <Loader loaded={this.state.loaded} />
          {renderErrorMessage(this.state.errors)}
          {questions}
          <br />
        </div>
      </div>
    );
  }

  addAnswer = e => {};
  removeAnswer = e => {};
  list_fullscreen = e => {};

  getQuestionsPage(page) {
    const self = this;
    this.questionsCall = getQuestions(page);
    this.questionsCall.promise.then(answer => {
      const questions = self.state.questions.concat(answer.questions);
      const total_pages = answer.total_pages;
      const loaded = answer.loaded;
      const errors = answer.errors;
      const can_load_more = true;
      self.setState({ questions, total_pages, loaded, errors, can_load_more });
    });
  }
}

export default ListQuestions;



// WEBPACK FOOTER //
// ./src/pages/listQuestions.jsx